import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const BookingSuccessRoute = ({ children }) => {
  const location = useLocation();
  const bookingData = location.state?.bookingData;

  // Check if user has valid booking data from successful booking
  if (!bookingData || !bookingData.id) {
    // Redirect to home page if no valid booking data
    return <Navigate to="/" replace />;
  }

  return children;
};

export default BookingSuccessRoute;
